import URI from "urijs";
import AppConfig from "util/AppConfig";
import {
  extendedSearchPath,
  viewsPath,
  dashboardsTvPath,
  showDashboardsPath,
  newDashboardsPath,
  dashboardsPath
} from "views/Constants";
export const SECURITY_PATH = "/security";
const Routes = {
  STARTPAGE: "/",
  NOTFOUND: "/notfound",
  SEARCH: "/search",
  SEARCH_SHOW: (id) => `/search/${id}`,
  STREAMS: "/streams",
  STREAM_NEW: "/streams/new",
  ALERTS: {
    LIST: "/alerts",
    replay_search: (alertId) => `/alerts/${alertId}/replay-search`,
    BULK_REPLAY_SEARCH: "/alerts/replay-search",
    DEFINITIONS: {
      LIST: "/alerts/definitions",
      CREATE: "/alerts/definitions/new",
      edit: (definitionId) => `/alerts/definitions/${definitionId}/edit`,
      show: (definitionId) => `/alerts/definitions/${definitionId}`,
      replay_search: (definitionId) => `/alerts/definitions/${definitionId}/replay-search`
    },
    NOTIFICATIONS: {
      LIST: "/alerts/notifications",
      CREATE: "/alerts/notifications/new",
      edit: (notificationId) => `/alerts/notifications/${notificationId}/edit`,
      show: (notificationId) => `/alerts/notifications/${notificationId}`
    }
  },
  SECURITY: {
    OVERVIEW: `${SECURITY_PATH}`,
    USER_ACTIVITY: `${SECURITY_PATH}/user-activity`,
    HOST_ACTIVITY: `${SECURITY_PATH}/host-activity`,
    NETWORK_ACTIVITY: `${SECURITY_PATH}/network-activity`,
    ANOMALIES: `${SECURITY_PATH}/anomalies`,
    ACTIVITY: `${SECURITY_PATH}/activity`
  },
  SOURCES: "/sources",
  DASHBOARDS: dashboardsPath,
  DASHBOARD: {
    NEW: newDashboardsPath,
    SHOW: showDashboardsPath,
    FULL_SCREEN: dashboardsTvPath
  },
  WELCOME: "/welcome",
  API_BROWSER: "/api-browser",
  SYSTEM: {
    CLUSTER: {
      NODES: "/system/cluster",
      NODE_SHOW: (nodeId) => `/system/cluster/node/${nodeId}`,
      CERTIFICATE_MANAGEMENT: "/system/cluster/certificate-management",
      DATANODE_DASHBOARD: "/system/cluster/datanode-dashboard",
      DATANODE_MIGRATION: "/system/cluster/datanode-migration",
      DATANODE_UPGRADE: "/system/cluster/datanode-upgrade",
      DATANODE_SHOW: (dataNodeId) => `/system/cluster/datanode/${dataNodeId}`
    },
    CONFIGURATIONS: "/system/configurations",
    configurationsSection: (section, pluginSection) => `/system/configurations/${section}${pluginSection ? `/${pluginSection}` : ""}`,
    CONTENTPACKS: {
      LIST: "/system/contentpacks",
      EXPORT: "/system/contentpacks/export",
      CREATE: "/system/contentpacks/create",
      edit: (contentPackId, contentPackRev) => `/system/contentpacks/${contentPackId}/${contentPackRev}/edit`,
      show: (contentPackId) => `/system/contentpacks/${contentPackId}`
    },
    GROKPATTERNS: "/system/grokpatterns",
    INDICES: {
      LIST: "/system/indices",
      FAILURES: "/system/indices/failures",
      TEMPLATES: {
        view: (templateId) => `/system/indices/templates/${templateId}`,
        OVERVIEW: "/system/indices/templates",
        CREATE: "/system/indices/templates/create",
        edit: (templateId) => `/system/indices/templates/edit/${templateId}`
      },
      FIELD_TYPE_PROFILES: {
        OVERVIEW: "/system/indices/field-type-profiles",
        edit: (profileId) => `/system/indices/field-type-profiles/${profileId}`,
        CREATE: "/system/indices/field-type-profiles/create"
      }
    },
    INDEX_SETS: {
      CONFIGURATION: (indexSetId, from) => {
        if (from) {
          return `/system/index_sets/${indexSetId}/configuration?from=${from}`;
        }
        return `/system/index_sets/${indexSetId}/configuration`;
      },
      SHOW: (indexSetId) => `/system/index_sets/${indexSetId}`,
      FIELD_TYPES: (indexSetId) => `/system/index_sets/${indexSetId}/field-types`,
      CREATE: "/system/index_sets/create"
    },
    INPUTS: "/system/inputs",
    INPUT_DIAGNOSIS: (input) => `/system/input/diagnosis/${input}`,
    LOGGING: "/system/logging",
    METRICS: (nodeId) => `/system/metrics/node/${nodeId}`,
    THREADDUMP: (nodeId) => `/system/threaddump/${nodeId}`,
    OUTPUTS: "/system/outputs",
    OVERVIEW: "/system/overview",
    PROCESSBUFFERDUMP: (nodeId) => `/system/processbufferdump/${nodeId}`,
    SYSTEMLOGS: (nodeId) => `/system/logs/recent/${nodeId}`,
    AUTHENTICATION: {
      BACKENDS: {
        OVERVIEW: "/system/authentication/services",
        ACTIVE: "/system/authentication/services/active",
        CREATE: "/system/authentication/services/create",
        createBackend: (name) => `/system/authentication/services/create/${name}`,
        show: (id) => `/system/authentication/services/${id}`,
        edit: (id, initialStepKey) => {
          const editUrl = `/system/authentication/services/edit/${id}`;
          if (initialStepKey) return `${editUrl}?initialStepKey=${initialStepKey}`;
          return editUrl;
        }
      },
      AUTHENTICATORS: {
        SHOW: "/system/authentication/authenticator",
        EDIT: "/system/authentication/authenticator/edit"
      }
    },
    USERS: {
      CREATE: "/system/users/new",
      edit: (userId) => `/system/users/edit/${userId}`,
      TOKENS: {
        edit: (userId) => `/system/users/tokens/${userId}`
      },
      OVERVIEW: "/system/users",
      show: (userId) => `/system/users/${userId}`
    },
    USERS_TOKEN_MANAGEMENT: {
      overview: "/system/tokenmanagement/overview"
    },
    AUTHZROLES: {
      OVERVIEW: "/system/roles",
      show: (roleId) => `/system/roles/${roleId}`,
      edit: (roleId) => `/system/roles/edit/${roleId}`
    },
    LOOKUPTABLES: {
      OVERVIEW: "/system/lookuptables",
      CREATE: "/system/lookuptables/create",
      show: (tableName) => `/system/lookuptables/table/${tableName}`,
      edit: (tableName) => `/system/lookuptables/table/${tableName}/edit`,
      CACHES: {
        OVERVIEW: "/system/lookuptables/caches",
        CREATE: "/system/lookuptables/caches/create",
        show: (cacheName) => `/system/lookuptables/caches/${cacheName}`,
        edit: (cacheName) => `/system/lookuptables/caches/${cacheName}/edit`
      },
      DATA_ADAPTERS: {
        OVERVIEW: "/system/lookuptables/data_adapters",
        CREATE: "/system/lookuptables/data_adapters/create",
        show: (adapterName) => `/system/lookuptables/data_adapter/${adapterName}`,
        edit: (adapterName) => `/system/lookuptables/data_adapter/${adapterName}/edit`
      }
    },
    PIPELINES: {
      CREATE: "/system/pipelines/new",
      OVERVIEW: "/system/pipelines",
      PIPELINE: (pipelineId) => `/system/pipelines/${pipelineId}`,
      RULES: "/system/pipelines/rules",
      RULE: (ruleId) => `/system/pipelines/rules/${ruleId}`,
      SIMULATOR: "/system/pipelines/simulate"
    },
    ENTERPRISE: "/system/enterprise",
    SIDECARS: {
      OVERVIEW: "/system/sidecars",
      STATUS: (sidecarId) => `/system/sidecars/${sidecarId}/status`,
      ADMINISTRATION: "/system/sidecars/administration",
      CONFIGURATION: "/system/sidecars/configuration",
      FAILURE_TRACKING: "/system/sidecars/failuretracking",
      NEW_CONFIGURATION: "/system/sidecars/configuration/new",
      EDIT_CONFIGURATION: (configurationId) => `/system/sidecars/configuration/edit/${configurationId}`,
      NEW_COLLECTOR: "/system/sidecars/collector/new",
      EDIT_COLLECTOR: (collectorId) => `/system/sidecars/collector/edit/${collectorId}`
    },
    COLLECTORS: {
      OVERVIEW: "/system/collectors",
      FLEETS: "/system/collectors/fleets",
      FLEETS_NEW: "/system/collectors/fleets/new",
      FLEET: (fleetId) => `/system/collectors/fleets/${fleetId}`,
      INSTANCES: "/system/collectors/instances",
      INSTANCE: (instanceId) => `/system/collectors/instances/${instanceId}`,
      DEPLOYMENT: "/system/collectors/deployment",
      SETTINGS: "/system/collectors/settings"
    }
  },
  VIEWS: {
    LIST: viewsPath,
    VIEWID: (id) => `${viewsPath}/${id}`
  },
  EXTENDEDSEARCH: extendedSearchPath,
  KEYBOARD_SHORTCUTS: "/keyboard-shortcuts",
  search_with_query: (query, rangeType, timeRange, streams, streamCategories) => {
    const route = new URI(Routes.SEARCH);
    const queryParams = {
      q: query
    };
    if (rangeType && timeRange) {
      queryParams.rangetype = rangeType;
      switch (rangeType) {
        case "relative":
          queryParams.relative = timeRange.relative;
          break;
        case "absolute":
          queryParams.from = timeRange.from;
          queryParams.to = timeRange.to;
          break;
        case "keyword":
          queryParams.keyword = timeRange.keyword;
          break;
        default:
          throw new Error(`Invalid range type: ${rangeType}.`);
      }
    }
    if (streams) {
      queryParams.streams = streams.join(",");
    }
    if (streamCategories) {
      queryParams.stream_categories = streamCategories.join(",");
    }
    route.query(queryParams);
    return route.resource();
  },
  _common_search_url: (resource, query, timeRange, resolution) => {
    const route = new URI(resource);
    const queryParams = {
      q: query,
      interval: resolution
    };
    if (timeRange) {
      Object.keys(timeRange).forEach((key) => {
        queryParams[key] = timeRange[key];
      });
    }
    route.setQuery(queryParams);
    return route.resource();
  },
  search: (query, timeRange, resolution) => Routes._common_search_url(Routes.SEARCH, query, timeRange, resolution),
  message_show: (index, messageId) => `/messages/${index}/${messageId}`,
  stream_view: (streamId) => `/streams/${streamId}/view`,
  stream_edit: (streamId) => `/streams/${streamId}/edit`,
  stream_edit_example: (streamId, index, messageId) => `${Routes.stream_edit(streamId)}?index=${index}&message_id=${messageId}`,
  stream_outputs: (streamId) => `/streams/${streamId}/outputs`,
  stream_search: (streamId, query, timeRange, resolution) => Routes._common_search_url(`${Routes.STREAMS}/${streamId}/search`, query, timeRange, resolution),
  stream_alerts: (streamId) => `/alerts/?stream_id=${streamId}`,
  dashboard_show: (dashboardId) => `/dashboards/${dashboardId}`,
  show_saved_search: (searchId) => `/search/${searchId}`,
  node_inputs: (nodeId) => `${Routes.SYSTEM.INPUTS}/${nodeId}`,
  global_input_extractors: (inputId) => `/system/inputs/${inputId}/extractors`,
  local_input_extractors: (nodeId, inputId) => `/system/inputs/${nodeId}/${inputId}/extractors`,
  export_extractors: (nodeId, inputId) => `${Routes.local_input_extractors(nodeId, inputId)}/export`,
  import_extractors: (nodeId, inputId) => `${Routes.local_input_extractors(nodeId, inputId)}/import`,
  new_extractor: (nodeId, inputId, extractorType, fieldName, index, messageId) => {
    const route = new URI(`/system/inputs/${nodeId}/${inputId}/extractors/new`);
    const queryParams = {
      extractor_type: extractorType,
      field: fieldName,
      example_index: index,
      example_id: messageId
    };
    route.search(queryParams);
    return route.resource();
  },
  edit_extractor: (nodeId, inputId, extractorId) => `/system/inputs/${nodeId}/${inputId}/extractors/${extractorId}/edit`,
  edit_input_extractor: (nodeId, inputId, extractorId) => `/system/inputs/${nodeId}/${inputId}/extractors/${extractorId}/edit`,
  filtered_metrics: (nodeId, filter) => `${Routes.SYSTEM.METRICS(nodeId)}?filter=${filter}`
};
const prefixUrlWithoutHostname = (url, prefix) => {
  const uri = new URI(url);
  return uri.directory(`${prefix}/${uri.directory()}`).normalizePath().resource();
};
const isLiteralRoute = (entry) => typeof entry === "string";
const isRouteFunction = (entry) => typeof entry === "function";
export const qualifyUrls = (routes, appPrefix = AppConfig.gl2AppPathPrefix()) => {
  if (!appPrefix || appPrefix === "" || appPrefix === "/") {
    return routes;
  }
  return Object.fromEntries(
    Object.entries(routes).map(([routeName, routeValue]) => {
      if (isLiteralRoute(routeValue)) {
        return [routeName, prefixUrlWithoutHostname(routeValue, appPrefix)];
      }
      if (isRouteFunction(routeValue)) {
        return [
          routeName,
          (...params) => {
            const result = routeValue(...params);
            return prefixUrlWithoutHostname(result, appPrefix);
          }
        ];
      }
      return [routeName, qualifyUrls(routeValue, appPrefix)];
    })
  );
};
export const prefixUrl = (route) => {
  const appPrefix = AppConfig.gl2AppPathPrefix();
  return !appPrefix || appPrefix === "" || appPrefix === "/" ? route : prefixUrlWithoutHostname(route, appPrefix);
};
const qualifiedRoutes = qualifyUrls(Routes);
const unqualified = Routes;
const defaultExport = {
  ...qualifiedRoutes,
  unqualified
};
export default defaultExport;
